import { ReferrerPortalBookingReason } from 'app/modules/referrer/book-online/models/referrer-portal-booking-reason.model';

export interface BookingReasonState {
  bookingReason?: ReferrerPortalBookingReason;
}

export const initialBookingReasonState: BookingReasonState = {
  bookingReason: undefined,
};
